/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Builders_SubmitInputs */

const en_directory_builders_submit = /** @type {(inputs: Directory_Builders_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit a product`)
};

const zh_directory_builders_submit = /** @type {(inputs: Directory_Builders_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交产品`)
};

/**
* | output |
* | --- |
* | "Submit a product" |
*
* @param {Directory_Builders_SubmitInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_builders_submit = /** @type {((inputs?: Directory_Builders_SubmitInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Builders_SubmitInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_builders_submit(inputs)
	return zh_directory_builders_submit(inputs)
});
export { directory_builders_submit as "directory.builders.submit" }